import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Frown, ExternalLink, Home } from "lucide-react";
import { Language } from "@/hooks/use-browser-language";

interface B2CExitScreenProps {
  onBackHome: () => void;
  language?: Language;
}

export const B2CExitScreen = ({ onBackHome, language = "pl" }: B2CExitScreenProps) => {
  const isEn = language === "en";
  
  return (
    <Card className="glass-card max-w-2xl mx-auto animate-fade-in">
      <CardContent className="p-8 md:p-12">
        <div className="text-center space-y-6">
          {/* Sad Icon */}
          <div className="flex justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-primary/20 blur-2xl rounded-full" />
              <Frown className="w-24 h-24 text-primary relative" strokeWidth={1.5} />
            </div>
          </div>

          {/* Title */}
          <h2 className="text-2xl md:text-3xl font-bold gradient-text">
            {isEn 
              ? "LinkedIn Social Selling is not effective for B2C and E-commerce"
              : "LinkedIn Social Selling nie jest efektywny dla B2C i E-commerce"}
          </h2>

          {/* Explanation */}
          <div className="space-y-4 text-muted-foreground">
            <p className="text-base md:text-lg">
              {isEn
                ? "LinkedIn is a B2B platform where professionals make business decisions. Social Selling works best in business-to-business relationships, not in consumer sales."
                : "LinkedIn jest platformą B2B, gdzie profesjonaliści podejmują decyzje biznesowe. Social Selling działa najlepiej w relacjach między firmami, nie w sprzedaży konsumenckiej."}
            </p>
            <p className="text-base">
              {isEn
                ? "For B2C and E-commerce, platforms like Instagram, Facebook, TikTok or Pinterest are better suited."
                : "Dla B2C i E-commerce lepsze będą platformy takie jak Instagram, Facebook, TikTok czy Pinterest."}
            </p>
          </div>

          {/* Divider */}
          <div className="relative py-4">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-border" />
            </div>
            <div className="relative flex justify-center text-xs uppercase">
              <span className="bg-card px-2 text-muted-foreground">
                {isEn ? "Still want to try?" : "Jednak chcesz spróbować?"}
              </span>
            </div>
          </div>

          {/* Call to action */}
          <p className="text-sm text-muted-foreground">
            {isEn
              ? "If you still believe you want to be present on LinkedIn:"
              : "Jeżeli jednak nadal uważasz, że chcesz zaistnieć na LinkedIn:"}
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 pt-4">
            <Button
              onClick={onBackHome}
              variant="outline"
              size="lg"
              className="flex-1"
            >
              <Home className="w-4 h-4" />
              {isEn ? "Return to homepage" : "Wróć do strony głównej"}
            </Button>
            
            <Button
              asChild
              size="lg"
              className="flex-1 gradient-primary"
            >
              <a
                href="https://lifactor.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2"
              >
                {isEn ? "Check lifactor.com" : "Sprawdź lifactor.com"}
                <ExternalLink className="w-4 h-4" />
              </a>
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
